// extracted by mini-css-extract-plugin
export default {"avatarContainer":"SenderMeta_avatarContainer__nH8ge","avatar":"SenderMeta_avatar__ZL+eu","senderName":"SenderMeta_senderName__djYuY"};